import './privacy-policy.sass';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';

function Privacy() {
  const { t } = useTranslation();
  return (
    <Container fluid className="privacy-container">
      <Privacy_intro />
      <Privacy_1 />
      <Privacy_2 />
      <Privacy_3 />
      <Privacy_4 />
      <Privacy_5 />
      <Privacy_6 />
      <Privacy_7 />
      <Privacy_8 />
      <Privacy_9 />
      <Privacy_10 />
      <Privacy_end />
    </Container>
  );
}

function Privacy_intro() {
  return (
    <Row>
      <Col>
        <h1 className="privacy-intro-title">
          <Trans i18nKey="privacy_intro_title" />
        </h1>
        <p className="privacy-intro-paragraph">
          <Trans i18nKey="privacy_intro_paragraph" />
        </p>
        <p>
          <Trans i18nKey="privacy_paragraph_1" />
        </p>
        <p>
          <Trans i18nKey="privacy_paragraph_2" />
        </p>
        <br />
      </Col>
    </Row>
  );
}

function Privacy_1() {
  return (
    <Row>
      <Col>
        <h4 className="h4-privacy">
          <Trans i18nKey="personal_data_title" />
        </h4>
        <p>
          <Trans i18nKey="personal_data_paragraph" />
        </p>
        <div>
          <h6>
            <Trans i18nKey="contact_details_title" />
          </h6>
          <p className="sub-paragraph">
            <Trans i18nKey="contact_details_paragraph" />
          </p>
        </div>
        <div>
          <h6>
            <Trans i18nKey="geolocation_title" />
          </h6>
          <p className="sub-paragraph">
            <Trans i18nKey="geolocation_paragraph" />
          </p>
        </div>
        <div>
          <h6>
            <Trans i18nKey="payment_details_title" />
          </h6>
          <p className="sub-paragraph">
            <Trans i18nKey="payment_details_paragraph" />
          </p>
        </div>
        <div>
          <h6>
            <Trans i18nKey="in_app_communication_title" />
          </h6>
          <p className="sub-paragraph">
            <Trans i18nKey="in_app_communication_paragraph" />
          </p>
        </div>
        <div>
          <h6>
            <Trans i18nKey="limited_identification_data_title" />
          </h6>
          <p className="sub-paragraph">
            <Trans i18nKey="limited_identification_data_paragraph" />
          </p>
        </div>
        <div>
          <h6>
            <Trans i18nKey="ride_data_title" />
          </h6>
          <p className="sub-paragraph">
            <Trans i18nKey="ride_data_paragraph" />
          </p>
        </div>
        <div>
          <h6>
            <Trans i18nKey="in_app_message_data_title" />
          </h6>
          <p className="sub-aragraph">
            <Trans i18nKey="in_app_message_data_paragraph" />
          </p>
        </div>
        <p>
          <Trans i18nKey="platform_data_collection" />
        </p>
        <p>
          <Trans i18nKey="usage_data_paragraph1" />
        </p>
        <p>
          <Trans i18nKey="usage_data_paragraph2" />
        </p>
        <p>
          <Trans i18nKey="website_app_visit_data" />
        </p>
        <p>
          <Trans i18nKey="cookies_tracking_technologies_title" />
        </p>
        <p>
          <Trans i18nKey="cookies_tracking_technologies_paragraph" />
        </p>
        <p>
          <Trans i18nKey="browser_cookie_options" />
        </p>
        <p>
          <Trans i18nKey="persistent_session_cookies" />
        </p>
        <p>
          <Trans i18nKey="cookies_usage_purpose" />
        </p>
        <p>
          <Trans i18nKey="necessary_essential_cookies" />
        </p>
        <p>
          <Trans i18nKey="session_cookies" />
        </p>
        <div>
          <h6>
            <Trans i18nKey="cookies_purpose_title" />
          </h6>
          <p className="sub-paragraph">
            <Trans i18nKey="cookies_purpose_paragraph" />
          </p>
        </div>
        <p>
          <Trans i18nKey="cookies_policy_notice_title" />
          <br />
          <Trans i18nKey="persistent_cookies" />
          <br />
          <Trans i18nKey="cookies_acceptance_paragraph" />
        </p>
        <p>
          <Trans i18nKey="functionality_cookies_paragraph" />
        </p>
        <p>
          <Trans i18nKey="cookies_functionality_paragraph" />
        </p>
        <p>
          <Trans i18nKey="cookies_more_info" />
        </p>
        <br />
      </Col>
    </Row>
  );
}

function Privacy_2() {
  return (
    <Row>
      <Col>
        <h4 className="h4-privacy">
          <Trans i18nKey="purpose_of_processing_title" />
        </h4>
        <p>
          <Trans i18nKey="purpose_of_processing_paragraph_1" />
        </p>
        <h5>
          <Trans i18nKey="connect_driver_title" />
        </h5>
        <p>
          <Trans i18nKey="connect_driver_paragraph" />
        </p>
        <h5>
          <Trans i18nKey="track_ride_title" />
        </h5>
        <p>
          <Trans i18nKey="track_ride_paragraph" />
        </p>
        <h5>
          <Trans i18nKey="smooth_journey_title" />
        </h5>
        <p>
          <Trans i18nKey="smooth_journey_paragraph" />
        </p>
        <h5>
          <Trans i18nKey="app_performance_title" />
        </h5>
        <p>
          <Trans i18nKey="app_performance_paragraph" />
        </p>
        <h5>
          <Trans i18nKey="quick_ride_title" />
        </h5>
        <p>
          <Trans i18nKey="quick_ride_paragraph" />
        </p>
        <h5>
          <Trans i18nKey="collect_payment_title" />
        </h5>
        <p>
          <Trans i18nKey="collect_payment_paragraph" />
        </p>
        <h5>
          <Trans i18nKey="maintain_standards_title" />
        </h5>
        <p>
          <Trans i18nKey="maintain_standards_paragraph" />
        </p>
        <h5>
          <Trans i18nKey="keep_informed_title" />
        </h5>
        <p>
          <Trans i18nKey="keep_informed_paragraph" />
        </p>
        <br />
      </Col>
    </Row>
  );
}

function Privacy_3() {
  return (
    <Row>
      <Col>
        <h4 className="h4-privacy">
          <Trans i18nKey="legal_basis_title" />
        </h4>

        <p>
          <Trans i18nKey="legal_basis_paragraph_1" />
        </p>
        <p>
          <Trans i18nKey="legal_basis_paragraph_2" />
        </p>
        <p>
          <Trans i18nKey="legal_basis_paragraph_3" />
        </p>
        <p>
          <Trans i18nKey="legal_basis_paragraph_4" />
        </p>
        <p>
          <Trans i18nKey="legal_basis_paragraph_5" />
        </p>
        <p>
          <Trans i18nKey="legal_basis_paragraph_6" />
        </p>
        <p>
          <Trans i18nKey="legal_basis_paragraph_7" />
        </p>
        <p>
          <Trans i18nKey="legal_basis_paragraph_8" />
        </p>
      </Col>
    </Row>
  );
}

function Privacy_4() {
  return (
    <Row>
      <Col>
        <h4 className="h4-privacy">
          <Trans i18nKey="recipients_title" />
        </h4>
        <p>
          <Trans i18nKey="recipients_paragraph_1" />
        </p>

        <p>
          <Trans i18nKey="recipients_paragraph_2" />
        </p>
        <br></br>
      </Col>
    </Row>
  );
}

function Privacy_5() {
  return (
    <Row>
      <Col>
        <h4 className="h4-privacy">
          <Trans i18nKey="security_title" />
        </h4>
        <p>
          <Trans i18nKey="security_paragraph_1" />
        </p>
        <br />
      </Col>
    </Row>
  );
}

function Privacy_6() {
  return (
    <Row>
      <Col>
        <h4 className="h4-privacy">
          <Trans i18nKey="children_privacy_title" />
        </h4>
        <p>
          <Trans i18nKey="children_privacy_paragraph_1" />
        </p>

        <p>
          <Trans i18nKey="children_privacy_paragraph_2" />
        </p>

        <p>
          <Trans i18nKey="children_privacy_paragraph_3" />
        </p>
        <br></br>
      </Col>
    </Row>
  );
}

function Privacy_7() {
  return (
    <Row>
      <Col>
        <h4 className="h4-privacy">
          <Trans i18nKey="links_title" />
        </h4>
        <p>
          <Trans i18nKey="links_paragraph_1" />
        </p>

        <p>
          <Trans i18nKey="links_paragraph_2" />
        </p>
        <br></br>
      </Col>
    </Row>
  );
}

function Privacy_8() {
  return (
    <Row>
      <Col>
        <h4 className="h4-privacy">
          <Trans i18nKey="changes_title" />
        </h4>
        <p>
          <Trans i18nKey="changes_paragraph_1" />
        </p>

        <p>
          <Trans i18nKey="changes_paragraph_2" />
        </p>

        <p>
          <Trans i18nKey="changes_paragraph_3" />
        </p>
        <br></br>
      </Col>
    </Row>
  );
}

function Privacy_9() {
  return (
    <Row>
      <Col>
        <h4 className="h4-privacy">
          <Trans i18nKey="rights_title" />
        </h4>
        <p>
          <Trans i18nKey="rights_paragraph_1" />
        </p>

        <p>
          <Trans i18nKey="rights_paragraph_2" />
        </p>
        <p>
          <Trans i18nKey="rights_paragraph_3" />
        </p>

        <p>
          <Trans i18nKey="rights_paragraph_4" />
        </p>

        <p>
          <Trans i18nKey="rights_paragraph_5" />
        </p>

        <p>
          <Trans i18nKey="rights_paragraph_6" />
        </p>

        <p>
          <Trans i18nKey="rights_paragraph_7" />
        </p>

        <p>
          <Trans i18nKey="rights_paragraph_8" />
        </p>

        <p>
          <Trans i18nKey="rights_paragraph_9" />
        </p>

        <p>
          <Trans i18nKey="rights_paragraph_10" />
        </p>

        <p>
          <Trans i18nKey="rights_paragraph_11" />
        </p>

        <br />
      </Col>
    </Row>
  );
}

function Privacy_10() {
  return (
    <Row>
      <Col>
        <h4 className="h4-privacy">
          <Trans i18nKey="retention_title" />
        </h4>
        <p>
          <Trans i18nKey="retention_paragraph_1" />
        </p>
        <p>
          <Trans i18nKey="retention_paragraph_2" />
        </p>
        <p>
          <Trans i18nKey="retention_paragraph_3" />
        </p>
        <p>
          <Trans i18nKey="retention_paragraph_4" />
        </p>
        <br />
      </Col>
    </Row>
  );
}

function Privacy_end() {
  return (
    <Row>
      <Col>
        <h4 className="h4-privacy">
          <Trans i18nKey="contact_title" />
        </h4>
        <p>
          <Trans i18nKey="contact_paragraph_1" />
          <br />
          <Trans i18nKey="contact_paragraph_2" />
        </p>
      </Col>
    </Row>
  );
}

export { Privacy };
